/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Kno2Info
 */
export interface Kno2Info {
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    last_name: string;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Info
     */
    birth_date: Date;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    zip_code?: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Info
     */
    country?: string;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Info
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the Kno2Info interface.
 */
export function instanceOfKno2Info(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "birth_date" in value;

    return isInstance;
}

export function Kno2InfoFromJSON(json: any): Kno2Info {
    return Kno2InfoFromJSONTyped(json, false);
}

export function Kno2InfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Kno2Info {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'birth_date': (new Date(json['birth_date'])),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip_code': !exists(json, 'zip_code') ? undefined : json['zip_code'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
    };
}

export function Kno2InfoToJSON(value?: Kno2Info | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'birth_date': (value.birth_date.toISOString().substring(0,10)),
        'gender': value.gender,
        'street': value.street,
        'city': value.city,
        'state': value.state,
        'zip_code': value.zip_code,
        'country': value.country,
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
    };
}

